/** Default slug after DB migration (npm run migrate:competitions on server). */
export const DEFAULT_COMPETITION_SLUG = 'main';

export const COMPETITION_STORAGE_KEY = 'bets_competition_slug';
